import React from "react";
import { MapPin, Phone } from "lucide-react";
import { AREAS_SERVED, BUSINESS } from "../lib/constants";

export default function AreasServed() {
  return (
    <section
      id="areas"
      data-testid="areas-section"
      aria-labelledby="areas-heading"
      className="py-24 md:py-32 border-t border-[#332C27] bg-[#14110F]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 reveal">
          <div className="max-w-2xl">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#F5A623] font-bold mb-4">
              / 03 — Where we work
            </div>
            <h2
              id="areas-heading"
              data-testid="areas-heading"
              className="font-display text-4xl md:text-5xl lg:text-6xl text-[#F9FAFB] font-semibold uppercase tracking-tight"
            >
              Handyman serving
              <br />
              <span className="text-[#F5A623]">
                Lehigh Acres, Fort Myers &amp; Cape Coral.
              </span>
            </h2>
          </div>
          <p className="text-[#A19D98] max-w-md text-base leading-relaxed">
            Family-owned and locally operated. If you're in Lee County,
            there's a good chance we're already working two streets over —
            give us a call.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {AREAS_SERVED.map((a, i) => (
            <article
              key={a.slug}
              data-testid={`area-card-${a.slug}`}
              className="reveal bg-[#1E1A18] border border-[#332C27] rounded-2xl p-7 md:p-8 hover:border-[#F5A623]/50 transition-colors flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-[#F5A623]/10 border border-[#F5A623]/20 flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-[#F5A623]" />
                </div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#F5A623] font-bold">
                  #{i + 1} City
                </div>
              </div>
              <h3 className="font-display text-2xl text-[#F9FAFB] font-semibold tracking-tight">
                Handyman in {a.city}
              </h3>
              <p className="text-[#A19D98] text-sm md:text-base leading-relaxed mt-3">
                {a.blurb}
              </p>
              <div className="mt-5 pt-5 border-t border-[#332C27]">
                <div className="text-[10px] uppercase tracking-[0.2em] text-[#A19D98] font-bold mb-2">
                  ZIPs we cover
                </div>
                <div className="text-xs text-[#F9FAFB] font-medium">
                  {a.zipHint}
                </div>
              </div>
              <a
                href={`tel:${BUSINESS.phoneRaw}`}
                data-testid={`area-call-${a.slug}`}
                className="mt-6 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.15em] text-[#F5A623] hover:text-[#F9FAFB] transition-colors"
              >
                <Phone className="w-4 h-4" />
                {BUSINESS.phone}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
